import { useAuth } from "./Auth";
export default (function (_impact, _feature) {
    var auth = useAuth();
    if ((auth.appConfig && auth.appConfig[_impact])) {
        return auth.appConfig[_impact].includes(_feature);
    }
});
